import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factor-rules/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Factor Rule'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
